module.exports = __webpack_public_path__ + "static/img/reservoir2.7cab4bbf.jpeg";